import { useState } from "react"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Popover from "react-bootstrap/Popover"

import { consoleLog } from "../utilities/helpers"
import { SCORE_THRESHOLD_HIGH, SCORE_THRESHOLD_MEDIUM } from "../const/numbers"

export function EditCommunityMemberModal({
    onClose,
    onSubmit,
    member,
    communityId,
}) {
    const [thresholdValue, setThresholdValue] = useState(
        member.threshold || SCORE_THRESHOLD_MEDIUM,
    )
    const [thresholdLabel, setThresholdLabel] = useState(
        getThresholdLabel(member.threshold || SCORE_THRESHOLD_MEDIUM),
    )
    const [thresholdClass, setThresholdClass] = useState(
        getThresholdClass(member.threshold || SCORE_THRESHOLD_MEDIUM),
    )

    function getThresholdLabel(value) {
        if (value >= SCORE_THRESHOLD_HIGH) return "High"
        if (value >= SCORE_THRESHOLD_MEDIUM) return "Medium"
        return "Low"
    }

    function getThresholdClass(value) {
        if (value >= SCORE_THRESHOLD_HIGH) return "success"
        if (value >= SCORE_THRESHOLD_MEDIUM) return "info"
        return "warning"
    }

    const popover = (
        <Popover id="popover-threshold-slider">
            <Popover.Header as="h3" className={`bg-${thresholdClass}`}>
                Safety Threshold
            </Popover.Header>
            <Popover.Body>
                Alert Level:{" "}
                <strong
                    className={`text-${thresholdClass}`}
                    style={{ textTransform: "capitalize" }}
                >
                    {thresholdLabel}
                </strong>
                <br />
                <small className="text-muted">
                    You'll be notified when safety drops below {thresholdValue}%
                </small>
            </Popover.Body>
        </Popover>
    )

    const handleThresholdChange = (event) => {
        const value = parseInt(event.target.value)
        setThresholdValue(value)
        setThresholdLabel(getThresholdLabel(value))
        setThresholdClass(getThresholdClass(value))
    }

    const handleSubmit = async (event) => {
        event.preventDefault()

        const updatedData = {
            communityId: communityId,
            memberId: member.id,
            memberType: member.type,
            threshold: thresholdValue,
        }

        consoleLog("Updating member threshold:", updatedData)

        try {
            if (onSubmit) {
                await onSubmit(updatedData)
            }
            onClose()
        } catch (error) {
            console.error("Error updating member threshold:", error)
        }
    }

    return (
        <div className="modal-content">
            <div className="modal-header mb-3">
                <h4>
                    <i className="bi bi-pencil-square pe-2"></i>
                    Edit Member Settings
                </h4>
            </div>
            <div className="modal-body p-3">
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <h6 className="fw-bold">
                            {member.full_name || member.username || member.name}
                        </h6>
                        <p className="text-muted small mb-0">
                            {member.country}
                        </p>
                    </div>

                    <hr />

                    <div className="mb-4">
                        <label htmlFor="thresholdSlider" className="form-label">
                            Safety Alert Threshold
                        </label>
                        <p className="text-muted small">
                            Set the safety level that will trigger
                            notifications. You'll be alerted when{" "}
                            <strong>
                                {member.full_name ||
                                    member.username ||
                                    member.name}
                            </strong>
                            's safety score drops below this threshold.
                        </p>

                        <OverlayTrigger placement="right" overlay={popover}>
                            <input
                                type="range"
                                className="form-range"
                                min="0"
                                max="100"
                                step="5"
                                id="thresholdSlider"
                                value={thresholdValue}
                                onChange={handleThresholdChange}
                            />
                        </OverlayTrigger>

                        <div className="d-flex justify-content-between mt-2">
                            <small className="text-muted">Low (0%)</small>
                            <kbd className={`bg-${thresholdClass}`}>
                                {thresholdLabel}: {thresholdValue}%
                            </kbd>
                            <small className="text-muted">High (100%)</small>
                        </div>
                    </div>

                    <div className="d-flex gap-2 justify-content-end">
                        <button type="submit" className="btn btn-dark">
                            <i className="bi bi-check-circle me-2"></i>
                            Save Changes
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}
